import { Colors } from '@zapier/design-system';
import { css } from '@emotion/core';

const Styles = {
  description: css`
    padding: 15px;
    padding-bottom: 0px;
  `,
  summaryList: css`
    margin-bottom: 0px;
    ::before {
      content: attr(title);
      padding-left: 15px;
      font-size: 13px;
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 23px;
      text-transform: uppercase;
    }
  `,
  summaryItem: css`
    border-top: 1px solid ${Colors.GrayWarm4};
    cursor: pointer;
    :first-of-type {
      margin-top: 10px;
    }
  `,
  passingDisplay: css`
    padding: 15px;
    margin-bottom: 20px;
  `,
  listTitle: css`
    padding: 15px;
  `,
  title: css`
    display: flex;
    justify-content: space-between;
  `,
};

export default Styles;
